

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface LabPackageParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface LabPackage {
    id?: any;
    sortOrderId:number;
    //labType:string;
    serviceId:any;
    labTestId:any;
    labGroupId:any;
    //isActive:string;
    tenantId: any;
    branchId: any;
    
    parameters?: LabPackageParameter[];
    links?: any;
}


export abstract class LabPackageData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<LabPackage[]>;
    abstract create(url: string, data: LabPackage): Observable<LabPackage[]>;
    abstract update(url: string, data: LabPackage): Observable<LabPackage>;
    abstract createList(url: string, data: any): Observable<any>;
    abstract updateList(url: string, data: any): Observable<any>;
    abstract delete(url: string): Observable<any>;
}
